import config from '../config.json'
import cacheService from './CacheService'
import { Catcher, SetterParams } from './Catcher'
const GetterCache = new Map()

var catcher = new Catcher()

export async function Getter(command: string, cache?: boolean, retryName?: string) {
  // console.log('catcher okay?', catcher)
  // catcher.RetryFilter(retryName || '', 'GET')
  if (cache && GetterCache.has(command)) {
    return GetterCache.get(command)
  }
  // console.log('fetch', command)
  try {
    // console.log('Getter', config, command, `${config.apiPrefix}${command}`)
    const response = await fetch(`${config.apiPrefix}${command}`)
    // console.log('Getter response', response.status)
    if (response.status === 401) {
      window.location.href = '/login'
      return
    }
    const r = await response.json()
    if (cache) {
      GetterCache.set(command, r)
    }
    catcher.RetryWalk(retryName || '', 'GET')
    return r
  } catch(err) {
    console.log('Getter did not succeed while fetching ' + command, err)
    if (retryName) {
      catcher.RetryAdd(command, {}, {kind: 'GET', retryName: retryName})
    }
  }
}

export async function Setter(command: string, body: object, params?: SetterParams)
: Promise<any>
{
  const url = `${params?.apiPrefix || config.apiPrefix}${command}`
  // console.log('Setter', command)
  return new Promise((success, fail) => {
    let method = params?.method || 'POST' 
    // let status = 'normal'
    cacheService.get(command, body, params).then((result) => {
      if (result !== false) {
        success(result)
        return
      }
      fetch(url, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(async (response) => {
        if (response.status === 401) {
          window.location.href = '/login'
          return
        }
        if (params?.apiPrefix) {
          // Wir sind im Testing Modus und wollen keine Retries:
          return
        }
        catcher.RetryWalk(params?.retryName || '', 'POST', command) // do not wait for this
        const result = await response.json()
        if (result.status === 'error') {
          // status = 'regular-error'
          throw(result.reason)
        }
        cacheService.set(command, body, params, result)
        success(result)
      }).catch((error) => {
        console.error('LOGIN?', error, command, body)
        catcher.RetryAdd(command, body, params)
        fail({
          desciption: 'fail',
          status: 'fail',
          error: error
        })
      })

    })
  })

}


export async function retryFetcher(url: string, options?: RequestInit): Promise <undefined | Response> {
  const maxRetries = 3
  const retryDelay = 3000
  for (let i = 0; i < maxRetries; i++) {
    try {
      let result = await fetch(url, options)
      return result
    } catch (error) {
      console.log(`retrying ${url} in ${retryDelay}ms`)
    }
    await new Promise(resolve => setTimeout(resolve, retryDelay));
  }
  console.error(`Giving up on ${url} after ${maxRetries} retries`)
  return undefined
  // throw error
}
